<template>
  <form id="live-streaming-send-gift-modal" action="">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">ギフトを贈る</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <div class="giftlist">
          <div
            v-for="(gift, index) in gifts"
            :key="index"
            :class="
              selectedGift && selectedGift.id == gift.id
                ? 'giftlist__item selected'
                : 'giftlist__item'
            "
            @click="onGiftSelected(gift)"
          >
            <div class="giftlist__image image">
              <img
                :src="gift.iconURL"
                width="280"
                height="244"
                class="is-rounded"
              />
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button label="閉じる" @click="$emit('close')" />
        <b-button label="贈る" @click="submit" type="is-primary" />
      </footer>
    </div>
  </form>
</template>

<script>
import moment from 'moment';

export default {
  name: 'LiveStreamingSendGiftModal',
  props: {
    commentRefObj: Object
  },
  computed: {
    gifts() {
      return this.$store.getters['live/gifts'];
    }
  },
  data() {
    return {
      selectedGift: null
    };
  },
  async created() {
    if (this.$store.state.live.gifts.length == 0) {
      await this.$store.dispatch('live/loadGifts');
    }
  },
  methods: {
    submit() {
      if (!this.selectedGift) return;
      // TODO: doronの量を検証
      const payload = {
        userId: this.$store.state.auth.uid,
        nickname: this.$store.state.user.nickname,
        photoURL: this.$store.state.user.photoURL,
        iconURL: this.selectedGift.iconURL,
        giftId: this.selectedGift.id,
        giftName: this.selectedGift.name,
        giftNameJP: this.selectedGift.nameJP,
        type: 'gift',
        timestamp: moment().unix()
      };
      this.selectedGift = null;
      let newMessageRef = this.commentRefObj.push();
      newMessageRef.set(payload);
      this.$emit('close');
    },
    onGiftSelected(gift) {
      this.selectedGift = gift;
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/live-streaming-send-gift-modal.scss';
.selected {
  background-color: #0abab555;
}
</style>
